import intl from 'react-intl-universal'
import en from './locales/en.json'
intl.init({
	currentLocale: 'en',
	locales: {
		en,
	},
})
export default intl
